<!--
  @description: 可筛选数字范围，如 27~100 之间的数据
  @date: 2022-03-21
  @Author: liushuo
-->
<template>
  <div class="my-filter-input">
    <vxe-input
      class="range-input"
      type="text"
      size="mini"
      v-model="option.data.val1"
      @keyup="keyupEvent"
      @input="changeOptionEvent"
    ></vxe-input>
    <span>~</span>
    <vxe-input
      class="range-input"
      type="text"
      size="mini"
      v-model="option.data.val2"
      @keyup="keyupEvent"
      @input="changeOptionEvent"
    ></vxe-input>
  </div>
</template>

<script>
export default {
  name: 'FilterInputRange',
  props: {
    params: Object,
  },
  data() {
    return {
      column: null,
      option: null,
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      const { column } = this.params
      const option = column.filters[0]
      this.column = column
      this.option = option
    },
    changeOptionEvent() {
      const { params, option } = this
      const { $panel } = params
      const checked = !!option.data
      $panel.changeOption(null, checked, option)
    },
    keyupEvent({ $event }) {
      const { params } = this
      const { $panel } = params
      if ($event.keyCode === 13) {
        // confirmFilter 会触发 format.js/VXETABLE.renderer.mixin 中的 filterMethod 方法
        $panel.confirmFilter()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.my-filter-input {
  display: flex;
  align-items: center;
  padding: 5px;

  > span {
    margin: 3px;
  }
}

.range-input {
  width: 50px;
}
</style>
